// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEpmMasterRoleTypeMutationVariables = Types.Exact<{
  input: Types.CreateEpmMasterRoleTypeInput;
}>;

export type CreateEpmMasterRoleTypeMutation = { __typename?: 'Mutation' } & {
  createEpmMasterRoleType: { __typename?: 'EpmMasterRoleTypeOutput' } & Pick<Types.EpmMasterRoleTypeOutput, 'id'>;
};

export const CreateEpmMasterRoleTypeDocument = /*#__PURE__*/ gql`
    mutation createEpmMasterRoleType($input: CreateEpmMasterRoleTypeInput!) {
  createEpmMasterRoleType(input: $input) {
    id
  }
}
    `;
export type CreateEpmMasterRoleTypeMutationFn = Apollo.MutationFunction<
  CreateEpmMasterRoleTypeMutation,
  CreateEpmMasterRoleTypeMutationVariables
>;

/**
 * __useCreateEpmMasterRoleTypeMutation__
 *
 * To run a mutation, you first call `useCreateEpmMasterRoleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpmMasterRoleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpmMasterRoleTypeMutation, { data, loading, error }] = useCreateEpmMasterRoleTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEpmMasterRoleTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEpmMasterRoleTypeMutation, CreateEpmMasterRoleTypeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEpmMasterRoleTypeMutation, CreateEpmMasterRoleTypeMutationVariables>(
    CreateEpmMasterRoleTypeDocument,
    options,
  );
}
export type CreateEpmMasterRoleTypeMutationHookResult = ReturnType<typeof useCreateEpmMasterRoleTypeMutation>;
export type CreateEpmMasterRoleTypeMutationOptions = Apollo.BaseMutationOptions<
  CreateEpmMasterRoleTypeMutation,
  CreateEpmMasterRoleTypeMutationVariables
>;
